import { apiClient, fileClient } from 'store';

export const apiCaller = (url, action) => {
  if (action && action.fakeCall) return {};
  const { method, path, params, data, fetchConfig } = action.payload;
  return apiClient[method](path, { params, data, fetchConfig });
};
export const fileCaller = async (url, action) => {
  if (action && action.fakeCall) return {};
  console.log(action.payload);
  const { method, path, params, data, fetchConfig } = action.payload;
  return fileClient[method](path, { params, data, fetchConfig });
};
